<template>
  <section>
    <p class="title is-2">Agregar productos</p>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag="router-link" to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item tag="router-link" to="/inventario"
        >Inventario</b-breadcrumb-item
      >
      <b-breadcrumb-item active>Agregar producto</b-breadcrumb-item>
    </b-breadcrumb>
    <form-producto @registrado="onRegistrado" :productoProp="producto" :borrarFormulario="borrarFormulario"/>
    <b-loading
      :is-full-page="true"
      v-model="cargando"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>
<script>
import FormProducto from "./FormProducto.vue";
import HttpService from "../../Servicios/HttpService";
import { NotificacionesMixin } from "../../components/mixins/NotificacionesMixin";

export default {
  name: "AgregarProducto",
  components: { FormProducto },
  mixins: [NotificacionesMixin],

  data: () => ({
    cargando: false,
    productos: [],
    borrarFormulario: false,
    producto: {
      codigo: "",
      nombre: "",
      precioCompra: "",
      precioVenta: "",
      precioVenta2: "",
      precioVenta3: "",
      existencia: 0,
      vendidoMayoreo: false,
      precioMayoreo: "",
      cantidadMayoreo: 0,
      categoria: "",
      marca: "",
      peso: 0,
      precioPromo: "",
      fechaInicio: "",
      fechaFin: "",
      inventarioMinimo: "",
    },
  }),

  mounted() {
    document.title = "Agregar/Producto";
  },

  methods: {
    onRegistrado(producto, productos) {
      this.cargando = true;
      let payload = {
        accion: "registrar",
        producto: producto,
        productos: productos,
      };
      HttpService.registrar("productos.php", payload).then((registrado) => {
        // Normaliza la respuesta por si hay espacios extra
        let resultado =
          typeof registrado === "string" ? registrado.trim() : registrado;

        if (resultado === "existe") {
          this.mostrarNotificacion(
            "warning",
            `El código "${producto.codigo}" ya existe.`
          );
          this.cargando = false;
          return;
        }

        if (registrado) {
          window.location.reload();

          this.cargando = false;
          this.mostrarNotificacion(
            "success",
            `Producto ${producto.nombre} registrado con éxito`
          );
        }
      });
    },
  },
};
</script>